import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PageChanger = ({ previousValue = false, nextValue = false, current = 1, onPageChange, pageValue = "dashboard", checkPage = false }) => {
    const [currentPage, setCurrentPage] = useState(current);
    const navigate = useNavigate()
    const handlePageClick = (page) => {
        setCurrentPage(page);
        if (onPageChange) {
            onPageChange(page);
        }
    };
    const previous = () => {
        if (currentPage > 1) {
            handlePageClick(currentPage - 1);
        }
    };
    const next = () => {
        if (nextValue) {
            handlePageClick(currentPage + 1);
        }
    };
    useEffect(() => {
        setCurrentPage(current);
    }, [current]);

    return (
        <div className="pc-container">
            <button className="pc-change" onClick={previous} disabled={currentPage === 1}>Previous</button>
            <div className='d-flex align-items-center'>
                <ul className="d-flex m-1">
                    {previousValue ? (
                        <>
                            <li className='me-1'>{checkPage ? (currentPage - 1) : <button className='link-btn' onClick={() => navigate(-1)}>{currentPage - 1}</button>}</li>
                            <li className='me-1'> | </li>
                        </>
                    ) : ""}
                    <li className='me-1'><span className="current-page">{currentPage}</span></li>
                    {nextValue ? (
                        <>
                            <li className='me-1'> | </li>
                            <li className='me-1'>{checkPage ? (currentPage + 1) : <button className='link-btn' onClick={() => {navigate(`/${pageValue}/${currentPage + 1}`)}}>{currentPage + 1}</button>}</li>
                        </>
                    ) : ""}
                </ul>
                {/* {`Showing ${currentPage} of ${totalPages.length} Pages - Total Entries ${total}`} */}
            </div>
            <button className="pc-change" onClick={next} disabled={!nextValue}>Next</button>
        </div>
    );
};

export default PageChanger;
